<ion-content class="ion-no-padding ion-no-border login" scrollY="false">
  <usucampeao-login-page [showCodePage]="showCodePage" [telefone]="phone"
   (onSetPhone)="setPhone($event)" (onSetCode)="setCode($event)" (onBackPhonePage)="backPhonePage()" (onResendCode)="resendCode()">
    <span>
      Acompanhe a regularização do seu imóvel. Para iniciar, digite o número do seu celular.
    </span>
  </usucampeao-login-page>
  <div id="recaptcha-container"></div>
</ion-content>
